import React from "react";

export const MyBooksTabIcon = (): JSX.Element => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.5203 8.4566L12 8.8557L12.4797 8.45659C14.071 7.1326 16.179 6.44532 17.9438 6.09571C18.8178 5.92257 19.5885 5.83593 20.1392 5.7927C20.1772 5.78972 20.2142 5.78694 20.25 5.78436V16.4503C20.2116 16.4537 20.172 16.4573 20.131 16.4612C19.6036 16.5116 18.8664 16.612 18.0166 16.8124C16.3246 17.2114 14.1419 18.0175 12.2909 19.6576C12.1308 19.7995 11.8692 19.7995 11.7091 19.6576C9.85805 18.0175 7.67537 17.2114 5.9834 16.8124C5.13358 16.612 4.39636 16.5116 3.86895 16.4612C3.82805 16.4573 3.78838 16.4537 3.75 16.4503V5.78437C3.78583 5.78695 3.82277 5.78972 3.86078 5.79271C4.41153 5.83594 5.18216 5.92258 6.05618 6.09572C7.82102 6.44534 9.929 7.13261 11.5203 8.4566Z"
        stroke="#020305"
        strokeWidth="1.5"
      />
      <path d="M12 8V14.5V19" stroke="#020305" strokeWidth="1.5" />
    </svg>
  );
};
